module.exports = __webpack_public_path__ + "static/img/pay_antpay@3x.cc07436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_antpay@3x.png
// module id = 6Hk3
// module chunks = 1